import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ThemesService } from '@app/core/themes/themes.service';
import { SettingsService } from '../core/settings/settings.service';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class LayoutComponent implements OnInit {

    isSuperAdmin : boolean = false;

    constructor(private settings: SettingsService, private router: Router, public themes: ThemesService) { 

        // Check token data
        if (localStorage.getItem("token") === null) {
            this.settings.sessionExpired();
            this.router.navigate(["/login"]);
        }

        this.isSuperAdmin = this.settings.isSuperAdmin();

    }

    ngOnInit() {
    }

}
